import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import TspSupplierReportData from './TspSupplierReportData';
import useFetch from '../../../hooks/useFetch';
import { Button, Modal } from "react-bootstrap"
import { exportToExcel } from '../../../services/fetch-data.service';
const EXPORT_TSPREPORT_API = 'https://dev.sustainabilitypro.io/api/v1/export-tsp-template'



export default function TspSupplierReport() {
  const { data, isLoading } = useFetch('tsp/getAllTsp');
  const [selectedYear, setSelectedYear] = useState('All');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null); // Reference to dropdown element

  useEffect(() => {
    console.log('Data:', data);
    console.log('Selected Year:', selectedYear);
  }, [data, selectedYear]);

  const filteredData =
    selectedYear === 'All'
      ? data
      : data.filter((item) => item.year.toString() === selectedYear.toString());

  useEffect(() => {
    console.log('Filtered Data:', filteredData);
  }, [filteredData]);

  // Toggle the dropdown open/close state
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // Handle the year selection and close the dropdown
  const handleSelectYear = (year) => {
    setSelectedYear(year);
    setDropdownOpen(false); // Close dropdown after selection
  };

  // Close the dropdown if clicked outside of it
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  const exporttspReport = () => {
    exportToExcel(EXPORT_TSPREPORT_API, 'tspReport')
};

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  if (isLoading) {
    return (
      <>
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h1 className="h2">
              <i className="fa-solid fa-spinner fa-spin"></i>
            </h1>
          </div>
        </main>
      </>
    );
  }

  return (
    <>
      <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          <h1 className="h2 float-start">
            <Link to={'/supplier-tsp-report'}>
              <i className="fa-solid fa-arrow-left"></i>
            </Link>
            TSP Supplier Report
          </h1>
          <div className="buttons-right supplier-filter"style={{padding:"5px"}} ref={dropdownRef} >
            <button className="btn btn-light"  onClick={toggleDropdown}>
              Select Year ({selectedYear}) <i className="fa-solid fa-caret-down" ></i>
            </button>

            {dropdownOpen && (
<ul className="dropdown-menu show" style={{ position: 'absolute', top: '100%', left: '0', zIndex: 1000, display: 'block' }}>
  <li className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => handleSelectYear('All')}>All</li>
  <li className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => handleSelectYear('2020')}>2020</li>
  <li className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => handleSelectYear('2021')}>2021</li>
  <li className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => handleSelectYear('2022')}>2022</li>
  <li className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => handleSelectYear('2023')}>2023</li>
  <li className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => handleSelectYear('2024')}>2024</li>
  <li className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => handleSelectYear('2025')}>2025</li>
</ul>
            )}
            <Link className="btn btn-light"style={{padding:"5px"}} to="/importreport">
              <i className="fa-solid fa-file-import"></i> Import Reports
            </Link>
            <button className='btn btn-primary btn-add'style={{padding:"5px"}} onClick={exporttspReport}  > <i class="fa-solid fa-file-import"></i> Export Report </button>
          </div>
        </div>
        <table className="table">
          <thead>
            <tr>
              <th>Seller</th>
              <th>Year</th>
              <th>Created Date</th>
              <th style={{paddingLeft:"30px"}}>Action</th>
            </tr>
          </thead>
          <tbody>
            <TspSupplierReportData data={filteredData} />
           
            
          </tbody>
          
        </table>
        
      </main>
    </>
  );
}
